import { connect } from 'react-redux';

import { IState } from '../../../store';
import { CommercialAboutBuilding, ICommercialAboutBuildingProps } from './index';

function mapStateToProps(state: IState): ICommercialAboutBuildingProps {
  return {
    building: state.offerData.offer.building,
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
  };
}

export const CommercialAboutBuildingContainer = connect<ICommercialAboutBuildingProps, {}, {}>(mapStateToProps)(
  CommercialAboutBuilding,
);
